import Image from 'next/image';
import imageUrlBuilder from '@sanity/image-url';
import { sanityDataset, sanityProjectId } from '@/lib/env';

export default function SanityImage(props: any) {
  const { className, height, sizes, src, width, alt, priority } = props;

  if (!src) {
    return null;
  }

  const urlBuilder = imageUrlBuilder({ dataset: sanityDataset, projectId: sanityProjectId }).image({
    _ref: src
  });

  return (
    <Image
      className={className}
      src={src}
      alt={alt || ''}
      width={width}
      height={height}
      sizes={sizes ?? undefined}
      priority={priority}
      placeholder="blur"
      blurDataURL={urlBuilder.width(30).blur(10).url()}
    />
  );
}
